import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="removals"
export default class extends Controller {
  static targets = ["timer"]

  connect() {
    // Animate the timer bar from 100% to 0% width over 3 seconds.
    if (this.hasTimerTarget) {
      this.timerTarget.animate(
        { width: ["100%", "0%"] },
        { duration: 3000, easing: "linear" }
      );
    }

    // Set a timeout to remove the element after 3 seconds.
    this.timeout = setTimeout(() => {
      this.remove()
    }, 3000)
  }

  disconnect() {
    // This is a Stimulus lifecycle method that is called when the controller
    // is removed from the DOM. We clear the timeout to prevent memory leaks.
    clearTimeout(this.timeout)
  }

  remove() {
    // Remove the element from the DOM
    this.element.remove()
  }
} 
